<script setup lang="ts">
import { useColorMode } from '@vueuse/core';
import { Check, Moon, Sun, SunMoon } from 'lucide-vue-next';
import { computed } from 'vue';

const mode = useColorMode();

// Set theme mode
function setTheme(newMode: 'light' | 'dark' | 'auto') {
  mode.value = newMode;
}

// Get current icon based on mode
const currentIcon = computed(() => {
  if (mode.value === 'light') {return Sun;}
  if (mode.value === 'dark') {return Moon;}
  return SunMoon;
});

// Get title for button
const title = computed(() => {
  if (mode.value === 'light') {return 'Light mode';}
  if (mode.value === 'dark') {return 'Dark mode';}
  return 'System mode';
});
</script>

<template>
  <UiDropdownMenu>
    <UiDropdownMenuTrigger as-child>
      <UiButton
        variant="outline"
        size="icon"
        class="h-10 w-10 cursor-pointer touch-action-manipulation"
        :title="title"
      >
        <component :is="currentIcon" class="h-5 w-5 transition-all" />
        <span class="sr-only">{{ title }}</span>
      </UiButton>
    </UiDropdownMenuTrigger>
    <UiDropdownMenuContent align="end">
      <UiDropdownMenuItem @click="setTheme('light')">
        <Sun class="mr-2 h-4 w-4" />
        <span>Light mode</span>
        <Check v-if="mode === 'light'" class="ml-auto h-4 w-4" />
      </UiDropdownMenuItem>
      <UiDropdownMenuItem @click="setTheme('dark')">
        <Moon class="mr-2 h-4 w-4" />
        <span>Dark mode</span>
        <Check v-if="mode === 'dark'" class="ml-auto h-4 w-4" />
      </UiDropdownMenuItem>
      <UiDropdownMenuItem @click="setTheme('auto')">
        <SunMoon class="mr-2 h-4 w-4" />
        <span>Follow system</span>
        <Check v-if="mode === 'auto'" class="ml-auto h-4 w-4" />
      </UiDropdownMenuItem>
    </UiDropdownMenuContent>
  </UiDropdownMenu>
</template>
